import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/@/components/ui/table';
import Iconify from 'src/components/Iconify';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function TableOrigins({ data, onEdit, onDelete }) {
  const { t } = useTranslation('settings');

  return (
    <Table>
      <TableHeader>
        <TableRow className="border-b border-[#f0f0f3] hover:bg-transparent">
          <TableHead className={`${D.tableHead} px-[26px]`}>{t('labels.name', { ns: 'common' })}</TableHead>
          <TableHead className={`${D.tableHead} text-right px-[26px]`}>
            {t('buttons.actions', { ns: 'common' })}
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.map((origin) => (
          <TableRow key={origin._id} className={D.tableRow}>
            <TableCell className={`${D.tableCell} font-medium px-[26px]`}>{origin.name}</TableCell>
            <TableCell className="text-right px-[26px]">
              <div className="flex justify-end gap-1.5">
                <button type="button" onClick={() => onEdit(origin)} className={D.iconButton}>
                  <Iconify icon="eva:edit-2-outline" width={14} />
                </button>
                <button type="button" onClick={() => onDelete(origin)} className={D.iconButtonDanger}>
                  <Iconify icon="eva:trash-2-outline" width={14} />
                </button>
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
